import { useEffect, useState } from "react";
import { useSelector, useStore } from "react-redux";

// components
import { Checkbox } from "shared/components/bulma/checkbox";

// redux
import { selectCustomerRecommendation, setRecommendation }
    from "hyc-store/reducers/customers/customer-recommendation";

// helpers
import * as helper from "./helper";

const ProductView = ({ category, data }) => {

    const store = useStore();
    const recommendations = useSelector(selectCustomerRecommendation);

    const [product, setProduct] = useState(null);
    const [chosen, setChosen] = useState(data?.chosen);

    const handleChange = async () => {

        const newChosen = !chosen;

        let recos = { ...recommendations };
        const catRecs = [...recos[category]];

        const index = catRecs.findIndex((catRecs) => catRecs.barcode === data.barcode);
        catRecs[index] = { ...catRecs[index], chosen: newChosen };
        recos[category] = catRecs;

        store.dispatch(setRecommendation(recos));
        await helper.setRecommendation({ recommendation: recos });

        if (newChosen) {
            const customer = { id: recos.customerId };
            await helper.setProductAsReserved({ customer, barcode: data.barcode });
            helper.setAllRecommendationsValue({ recommendation: recos, barcode: data.barcode });
        }

        setChosen(newChosen);
    }

    useEffect(() => {
        const getProduct = async () => {
            const d = await helper.getProduct({ barcode: data.barcode });
            setProduct(d);
        }

        if (data) {
            getProduct();
        }
    }, [data]);

    if (!product) {
        return null;
    }

    return (
        <div className="card">
            <footer className="card-footer">
                <p className="card-footer-item">{product.size}</p>
                <p className="card-footer-item">{product.location}</p>
            </footer>

            <footer className="card-footer">
                <p className="card-footer-item">{data.barcode}</p>
            </footer>

            <div className="card-image">
                <figure className="image is-square">
                    <img src={product.imageURLs[0]} alt={data.barcode} />
                </figure>
            </div>

            <footer className="card-footer">
                <p className="card-footer-item">
                    <Checkbox
                        onChange={handleChange}
                        id={`checkbox-id-${data.barcode}`}
                        name={`checkbox-name-${data.barcode}`}
                        checked={chosen}>
                        Chosen
                    </Checkbox>
                </p>
            </footer>
        </div>
    );
}

export { ProductView };
